/**
 * Advances keyboard focus to the next focusable element in the form, skipping elements
 * inside the same Select container. Used by Select's autoAdvance feature to move focus
 * to the next field after a single-select value is picked.
 */
const FOCUSABLE = 'a[href], button:not([disabled]), input:not([disabled]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"]):not([disabled])';

export default function advanceFocusFrom(element: HTMLElement | null | undefined) {
    if (!element) return;

    // Find the Select container
    const selectContainer = element.closest('.react-select-container');

    // Search within the nearest form, or fall back to document body
    const scope = element.closest('form') || document.body;

    // Gather all visible, focusable elements in DOM order
    const all = Array.from(scope.querySelectorAll<HTMLElement>(FOCUSABLE))
        .filter(el => el.offsetParent !== null || el.tagName === 'BODY');

    // Find where our element (or its container) sits in the tab order
    const currentIndex = all.indexOf(element);
    if (currentIndex < 0) return;

    // Walk forward to find the first focusable element outside our Select container
    for (let i = currentIndex + 1; i < all.length; i++) {
        if (selectContainer && selectContainer.contains(all[i])) continue;
        setTimeout(() => all[i].focus(), 0);
        return;
    }
}
